export default "__VITE_ASSET__CQJHtIhw__"